import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalService, AlertService } from '@edassist/shared';
import { AuthenticationService } from '../services/auth/auth.service';
import { constants } from '@edassist/common';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constants = constants;
	constructor(
		private readonly authenticationService: AuthenticationService,
		private readonly alertService: AlertService,
		private readonly modalService: ModalService
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				let errorMessage = '';
				if (error.status === 401) {
					// auto logout if 401 response returned from api
					this.authenticationService.logout();
					this.modalService.closeAll();
				} else if (error.error instanceof ErrorEvent) {
					// A client-side or network error occurred. Handle it accordingly.
					errorMessage = `An error occured: ${error.error.message}`;
					this.alertService.error(errorMessage);
				} else {
					// The backend returned an unsuccessful response code.
					// error.error.message will be the 'friendly' error message from the backend
					// To avoid console errors, let's fallback to the error.message if the error property doesn't exist
					if (
						Object.keys(constants.applicationActionMenuError).includes(
							error.error?.message ?? error.message
						)
					) {
						this.alertService.error(
							constants.applicationActionMenuError[
								error.error?.message ?? error.message
							]
						);
					} else {
						this.alertService.error(error.error?.message || error.message);
					}
				}

				return throwError(error);
			})
		);
	}
}
